import { render, staticRenderFns } from "./JSuperQueryNew.vue?vue&type=template&id=24812ba3&scoped=true"
import script from "./JSuperQueryNew.vue?vue&type=script&lang=js"
export * from "./JSuperQueryNew.vue?vue&type=script&lang=js"
import style0 from "./JSuperQueryNew.vue?vue&type=style&index=0&id=24812ba3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24812ba3",
  null
  
)

export default component.exports